import i18next from 'i18next'

const transStatic = (needTranslate: boolean, args: string): string => {
  const [text, context] = args.split(',')

  if (!text) {
    return ''
  }

  if (!context || !needTranslate) {
    return text
  }

  return i18next.t(text, { ns: context })
}

export default transStatic
